import { render } from "./CreatePassword.vue?vue&type=template&id=43dd745c"
import script from "./CreatePassword.vue?vue&type=script&lang=js"
export * from "./CreatePassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__